export default {
    totemsArray : [],
    formasServicio : [
        {
            text : 'Recoger Mostrador',
            value : 'recoger'
        },
        {
            text : 'Servir en Mesa',
            value : 'mesa'
        },
        {
            text : 'Domicilio',
            value : 'domicilio'
        },
    ],
    formasPago : [
        {
            text : 'Tarjeta',
            value : 'tarjeta'
        },
        {
            text : 'Efectivo',
            value : 'efectivo'
        },
        {
            text : 'Efectivo en totem',
            value : 'efectivo-totem'
        },
    ]

}